"use client";

import useWindowSize from "@/hooks/useWindowSize";
import {
  Carousel,
  CarouselContent,
  CarouselNavigation,
} from "@aleksundshantu/aunds-utils-react/primitives/carousel";
import { useMemo } from "react";
import { BreakpointWidths } from "./QuoteSlider";
import styles from "./QuoteSliderWrapper.module.scss";

const useDeviceType = () => {
  const { width } = useWindowSize();

  return useMemo(() => {
    if (width >= 1920) return "ultrahd";
    if (width >= 1408) return "fullhd";
    if (width >= 1216) return "widescreen";
    if (width >= 1024) return "desktop";
    if (width >= 769) return "tablet";
    return "mobile";
  }, [width]);
};

export const QuoteSliderWrapper = ({
  children,
  width_breakpoints,
  autoplay,
  sliderNavigation,
}: {
  children: React.ReactNode;
  width_breakpoints: BreakpointWidths;
  autoplay: boolean;
  sliderNavigation:
    | "navigation-pagination"
    | "only-navigation"
    | "only-navigation-autoplay";
}) => {
  const screenSize = useDeviceType();

  const activeBreakpointValue = width_breakpoints[screenSize];
  const isFull = activeBreakpointValue === "100%";
  return (
    <Carousel
      className={styles.carousel}
      hasFade={isFull}
      containScroll={false}
      autoplay={autoplay}
      align={"start"}
    >
      <div className={styles["mobile-navigation"]}>
        <CarouselNavigation
          className={sliderNavigation}
          type={sliderNavigation}
        />
      </div>
      <CarouselContent
        outerPadding="0"
        spacing={`2rem`}
        overflowVisible={isFull}
      >
        {children}
      </CarouselContent>
      <div className={styles["tablet-navigation"]}>
        <CarouselNavigation
          className={sliderNavigation}
          type={sliderNavigation}
        />
      </div>
    </Carousel>
  );
};
